import React from 'react'
import tooltip from '../../../assets/images/lapiz.png'

const ImgPencil = () => {
  return (
    <img height={"20px"} width={"20px"} style={{ marginBottom: "2px" }} src={tooltip} />
  )
};

export default ImgPencil;